import React, { useState } from 'react';
import { Checkbox, Responsive } from 'vendors/semantic-ui';

import { configUI } from 'config';

import { getContractCDNUrl } from 'modules/shared/utils';
import { useRouter } from 'modules/shared/hooks';
import { ClassicButton } from 'modules/shared-ui/components';

import { ContractFormProps } from './contract-form-type';

import styles from './contract-form-component.module.css';

export const ContractForm: React.FC<ContractFormProps> = ({ universeType, onValidate, onBack }: ContractFormProps) => {
    const [cguAccepted, setCguAccepted] = useState(false);

    const { history } = useRouter();

    return (
        <React.Fragment>
            <div className={styles.container}>
                <div className={styles.disclaimer}>
                    <Responsive as={React.Fragment} minWidth={configUI.responsive.tablet.minWidth}>
                        <div className={styles.disclaimerTitle}>Mon Contrat</div>
                    </Responsive>
                    <div className={styles.disclaimerText}>
                        Pour ouvrir votre liste, nous vous invitons a lire attentivement les conditions générales de
                        vente en cochant la case située en bas de page. Suite à votre validation, votre liste sera alors
                        ouverte et vous pourrez commencer à recevoir des dons.
                    </div>
                </div>
                <div className={styles.cguContainer}>
                    <div className={styles.cguTitle}>Conditions générales du compte Printemps Listes</div>
                    <div className={styles.cguReader}>
                        <iframe title="contract" src={getContractCDNUrl()} />
                    </div>
                </div>
                <div className={styles.validationContainer}>
                    <div className={styles.links}>
                        <a
                            href={getContractCDNUrl()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.validationDownloadLink}
                        >
                            Téléchargez le contrat
                        </a>{' '}
                        (Si vous souhaitez télécharger Adobe Acrobat,{' '}
                        <a
                            href="http://www.adobe.fr/products/acrobat/readstep.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.validationAdobeLink}
                        >
                            cliquez ici
                        </a>
                        )
                    </div>
                    <div>
                        <Checkbox
                            label="J'accepte les conditions générales pour la création de mon dossier.*"
                            onChange={() => setCguAccepted(!cguAccepted)}
                        />
                    </div>
                    <div className={styles.infos}>
                        Votre liste sera ouverte aux dons dès la validation du présent formulaire
                    </div>
                    <div className={styles.actions}>
                        <ClassicButton text="REVENIR" onClick={onBack} />
                        <ClassicButton
                            text="VALIDER"
                            disabled={!cguAccepted}
                            onClick={() => {
                                onValidate();
                                history.push(`/listes/creer-liste/confirmation/${universeType}`);
                            }}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
